export default __webpack_public_path__ + "static/banksmilessingleline-571551207fca7487b68f7a8c9acd47e1.woff";